import React from 'react';
import PropTypes from 'prop-types';
import UiKitConfirmModal from 'components/UiKit/ConfirmModal';
import { Table } from 'syngenta-digital-cropwise-react-ui-kit';
import 'styles/uiKitTableReset.css';
import './index.css';

import FormattedNumber from 'components/FormattedNumber';

const CONFLICT_COLUMNS = [
  {
    key: 'farm',
    render: (_, cropZone) => <p className="font-body">{cropZone.farmName}</p>
  },
  {
    key: 'field',
    render: (_, cropZone) => <p className="font-body">{cropZone.fieldName}</p>
  },
  {
    key: 'cropZone',
    render: (_, cropZone) => (
      <div className="w-full font-body">
        <p className="text-left">{cropZone.name}</p>
        <p className="text-neutral-600 text-sm text-left mt-2">
          <FormattedNumber roundedTo={2}>
            {cropZone.boundaryArea}
          </FormattedNumber>
          {` • ${cropZone.crop.name}`}
        </p>
      </div>
    )
  }
];

const DeleteCropZoneModalSummaryConflicts = ({
  open,
  onClose,
  cropzonesToDelete
}) => {
  return (
    <>
      <UiKitConfirmModal
        open={open}
        onCancel={onClose}
        onConfirm={onClose}
        close={onClose}
        title="Delete CropZones"
      >
        <h1 className="mt-3 font-body">
          The following selected crop zones cannot be deleted due to associated
          records:
        </h1>
        <div className="table-layout mt-4">
          <div className="cwf-table-flush">
            <Table
              showHeader={false}
              pagination={false}
              rowKey={cropZone =>
                `${cropZone.farmName}-${cropZone.fieldName}-${cropZone.name}`
              }
              dataSource={cropzonesToDelete}
              columns={CONFLICT_COLUMNS}
            />
          </div>
        </div>
      </UiKitConfirmModal>
    </>
  );
};

DeleteCropZoneModalSummaryConflicts.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  cropzonesToDelete: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default DeleteCropZoneModalSummaryConflicts;
